const QUESTION_TYPE_LABELS = {
  1: 'General Practice',
  2: 'Interview Questions',
  3: 'Active Interview',
} as const

interface Props {
  questionType: string
}

function QuestionTypeLabel({ questionType }: Props) {
  // Coding Questions used to return 1 | 2 | 3 strings for questionType
  // It now returns a a string label and dealt with similarly to Non-coding Questions below.
  // TODO: removed this once the switch is complete
  const intType = parseInt(questionType, 10)
  if (intType in QUESTION_TYPE_LABELS) {
    return (
      <span>
        {QUESTION_TYPE_LABELS[intType as keyof typeof QUESTION_TYPE_LABELS]}
      </span>
    )
  }

  // Capitalize questionType
  return (
    <>
      {(questionType as string)
        .split(' ')
        .map((w) => w[0].toUpperCase() + w.slice(1))
        .join(' ')}
    </>
  )
}

export default QuestionTypeLabel
